function convertFormDataWithArray(body: any) {
  const formData = new URLSearchParams();

  Object.keys(body).forEach((key) => {
    const value = body[key];
    // 값이 배열인 경우, 각 요소를 별도로 추가
    if (Array.isArray(value)) {
      value.forEach((item) => {
        formData.append(`${key}[]`, item);
      });
    } else {
      // 값이 배열이 아닌 경우, 기존 방식대로 추가
      formData.append(key, value);
    }
  });

  return formData;
}

export default convertFormDataWithArray;
